import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common_fr from './fr.json';
import common_en from './en.json';

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'fr',
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      fr: {
        common: common_fr
      },
      en: {
        common: common_en
      }
    }
  });


export default i18n;